import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, switchMap, take, tap } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { Contract } from '../../modules/admin/contract/contract.types';
import Urls from '../../helpers/urls';
import Utils from '../../helpers/utils';
import {Auth, sendEmailVerification} from "@angular/fire/auth";
import {DateTime} from "luxon";

@Injectable({
    providedIn: 'root'
})
export class UserService
{
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    /**
     * Constructor
     */
    constructor(
      private _httpClient: HttpClient,
      private _fireAuth: Auth
      )
    {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User)
    {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User>
    {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    get(): Observable<User>
    {
        return this._httpClient.get<User>('api/common/user').pipe(
            tap((user) => {
                this._user.next(user);
            })
        );
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any>
    {
        return this._httpClient.patch<User>('api/common/user', {user}).pipe(
            map((response) => {
                this._user.next(response);
            })
        );
    }

    refreshTokenIfNeeded(){
        let currentDateTime: DateTime = DateTime.now();
        let tokenExpireAt;
        let userToUpdate;
        this.user$.subscribe((user) => {
          userToUpdate = user;
          tokenExpireAt = user.tokenExpireAt;
        });
        if (tokenExpireAt < currentDateTime) {
            this._fireAuth.currentUser.getIdToken(true).then(function(idToken) {
               console.log('getIdToken: ' + idToken);
               userToUpdate.token = idToken;
               userToUpdate.tokenExpireAt = Utils.getIdTokenExpirationDateTime();
               console.log("User idToken Refreshed");
            }).catch(function(error) {
                console.log('getIdToken: ' +error);
            });
        }
    }
}
